import { CommandGetSftpSettings } from "./commands/cmdGetSftpSettings";
import { CommandCreateSftpKey, CreateSftpKeyPayload } from "./commands/cmdCreateSftpKey";
import { CommandDeleteSftpKey } from "./commands/cmdDeleteSftpKey";
import { CommandGetSftpInstructions } from "./commands/cmdGetSftpInstructions";
import { CommandGetSftpInstructionsMarkdown } from "./commands/cmdGetSftpInstructionsMarkdown";

export class SftpService {
  async getSettings(organizationId: number) {
    return new CommandGetSftpSettings().run(organizationId);
  }

  async createKey(organizationId: number, payload: CreateSftpKeyPayload) {
    return new CommandCreateSftpKey().run(organizationId, payload);
  }

  async deleteKey(organizationId: number, keyId: number) {
    return new CommandDeleteSftpKey().run(organizationId, keyId);
  }

  async getInstructions() {
    return new CommandGetSftpInstructions().run();
  }

  async getInstructionsMarkdown(organizationId: number) {
    return new CommandGetSftpInstructionsMarkdown().run(organizationId);
  }
}
